module.exports = __webpack_public_path__ + "img/warning-big.97a6fd58.svg";